import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=66b63a95&scoped=true"
import script from "./LogoUpload.vue?vue&type=script&lang=js"
export * from "./LogoUpload.vue?vue&type=script&lang=js"
import style0 from "./LogoUpload.vue?vue&type=style&index=0&id=66b63a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b63a95",
  null
  
)

export default component.exports